import React, { useRef } from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import ProductCard from '../components/ProductCard'

const HomeScreen = () => {

    const productRef = useRef()
    const contactRef = useRef()

    return (
        <div className="min-h-screen h-full bg-black">
            <Navbar productRef={productRef} contactRef={contactRef}/>
            <div className="pl-20 pr-20">
                <div className="flex h-screen -mt-20">
                    <div className="m-auto space-y-4">
                        <p className="text-white text-5xl font-bold text-center">Building Products to Connect the People Around You</p>
                        <p className="text-konnect-purple text-3xl font-bold text-center">A student built company</p>
                    </div>
                </div>
                <div className="space-y-10 h-screen" ref={productRef}>
                    <div className="pt-10">
                        <p className="text-white font-bold text-4xl text-center">Products</p>
                    </div>
                    <div className="flex justify-center">
                        <ProductCard />
                    </div>
                </div>
                <div ref={contactRef}>
                    <div className="space-y-4">
                        <p className="text-white font-bold text-4xl text-center">Contact</p>
                        <p className="text-white text-center text-xl">Email: info@konnectenterprisesllc.com</p>
                    </div>
                </div>
            </div>
            <Footer productRef={productRef} contactRef={contactRef}/>
        </div>
    )
}

export default HomeScreen

